/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateProfileComponent } from './create-profile/create-profile.component';
import { ManageProfileComponent } from './manage-profile/manage-profile.component';
import { CanAuthenticationGuard } from '../providers/auth-guard';
import { ConfigureProfileComponent } from './configure-profile/configure-profile.component';

/**
  * @ngdoc overview
  * @name MODULE_NAME.module:ProfilesModule
  *
  * @description
  * description: To route to different components in profiles module based on the path given
*/
const routes: Routes = [
  {
    path: 'profiles/create-profiles',
    component: CreateProfileComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'BP_C', data: {} }
  },
  {
    path: 'profiles/manage-profiles',
    component: ManageProfileComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'BP_R', data: {} }
  },
  {
    path: 'configure-profiles',
    component: ConfigureProfileComponent,
    canActivate: [CanAuthenticationGuard],
    data: { permission: 'BP_C', data: {} }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfilesRoutingModule { }
